import {
  Divider,
  FormControl,
  FormLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Fragment, useState } from 'react';

import { RoleAccordionBody } from '@/components/permissions/scopeAccordion';
import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';

import type { UpsertUserState } from './upsertUserFlow';
import { UserBadge } from './userBadge';

export const UpsertUserStep = (props: StepProps<UpsertUserState>) => {
  const [emailError, setEmailError] = useState(false);

  return (
    <>
      <StepContainer
        hideStepper
        onBackClick={props.back}
        canGoNext={() =>
          !emailError &&
          !!props.wizardState.email &&
          !!props.wizardState.givenName &&
          !!Object.keys(props.wizardState.roleToProjectsMappings).length
        }
        nextButtonText={props.wizardState.id ? 'Save Changes' : 'Invite'}
        backButtonText='Cancel'
        onNextClick={() => props.finish()}
      >
        <Stack gap='12px'>
          {props.wizardState.id && (
            <UserBadge
              user={props.wizardState}
              className='mx-[60px] pb-[12px]'
            />
          )}
          {!props.wizardState.id && (
            <>
              <Typography variant='h4' className='mx-[60px] font-semibold'>
                Personal details
              </Typography>
              <Stack
                gap='16px'
                className='px-[60px] py-[12px] w-1/2'
                direction='row'
              >
                <FormControl size='small' className='w-1/2'>
                  <FormLabel>Name</FormLabel>
                  <TextField
                    value={props.wizardState.givenName}
                    onChange={(event) =>
                      props.setWizardState((state) => ({
                        ...state,
                        givenName: event.target.value,
                      }))
                    }
                  />
                </FormControl>
                <FormControl size='small' className='w-1/2'>
                  <FormLabel>Email</FormLabel>
                  <TextField
                    error={emailError}
                    helperText={emailError ? 'Invalid email' : ''}
                    onChange={(event) => {
                      props.setWizardState((state) => ({
                        ...state,
                        email: event.target.value,
                      }));
                      setEmailError(!event.target.validity.valid);
                    }}
                    inputProps={{
                      type: 'email',
                    }}
                    value={props.wizardState.email}
                  />
                </FormControl>
              </Stack>
            </>
          )}
          {!props.wizardState.id && (
            <>
              <Divider sx={{ mx: '-40px', my: '12px' }} />
              <Typography
                variant='h4'
                className='mt-[12px] mx-[60px] font-semibold'
              >
                Permissions
              </Typography>
            </>
          )}
          <Stack gap='12px' className='ml-[60px]'>
            <Typography variant='body1' className='my-[24px]'>
              Edit the permissions this user has by assigning roles
            </Typography>
            <RoleAccordionBody
              roleToProjectsMappings={props.wizardState.roleToProjectsMappings}
              onChange={(roleToProjectsMappings) =>
                props.setWizardState((state) => ({
                  ...state,
                  roleToProjectsMappings: { ...roleToProjectsMappings },
                }))
              }
            />
          </Stack>
        </Stack>
      </StepContainer>
    </>
  );
};
